// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getPipStatuses} from '../../../pip/shared/repositories';

export const readPipStatuses = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const pipStatuses = await getPipStatuses();

            dispatch({
                pipStatuses,
                type: actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/read-pip-statuses.js